"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringColorToHex = exports.colorConfigParser = exports.colorMapper = void 0;
// I colori sono da sistemare non appena ci arrivano i dettagli
var colorMap = {
    Bianco: "#FFF",
    "U-Blue": "#E2F0F9",
    "Grigio Chiaro": "#F1F1F1",
    Trasparente: "transparent",
};
var defaultColor = "U-Blue";
function colorMapper(colorMapConfig) {
    return stringColorToHex(colorConfigParser(colorMapConfig));
}
exports.colorMapper = colorMapper;
function colorConfigParser(colorMapConfig) {
    var color = colorMapConfig.find(function (item) { return item.selected === "true"; });
    return color ? color.value : defaultColor;
}
exports.colorConfigParser = colorConfigParser;
function stringColorToHex(stringColor) {
    return colorMap[stringColor] != undefined
        ? colorMap[stringColor]
        : colorMap[defaultColor];
}
exports.stringColorToHex = stringColorToHex;
